const AxiosFactory = require('../axios/AxiosFactory');

const kubeClient = AxiosFactory.createKubeInstance();
const kubeInstance = kubeClient.getInstance();

/**
 * @typedef {Object} PortalFiltersResponseFilterItem
 * @property {string} name
 * @property {string|number} value
 * @property {string} code
 * @property {string} fullCode
 */

/**
 * @typedef {Object} PortalFiltersResponseFilter
 * @property {string} name
 * @property {string} type
 * @property {true} filter
 * @property {string} code
 * @property {boolean} expanded
 * @property {PortalFiltersResponseFilterItem[]} items
 */

/**
 * @typedef {Object} PortalFiltersResponseAutocomplete
 * @property {string} code
 * @property {string} name
 */

/**
 * @typedef {Object} PortalFiltersResponse
 * @property {PortalFiltersResponseFilter[]} filters
 * @property {PortalFiltersResponseAutocomplete[]} autocomplete
 */

/**
 * @param {string} channelId
 * @param {string} languageCode
 * @returns {Promise<PortalFiltersResponse>}
 */
const getPortalFilters = (channelId, languageCode) => kubeInstance
    .get(`/portalFilters?channelId=${channelId}&languageCode=${languageCode.toUpperCase()}`)
    .then(response => response.data);

module.exports = { getPortalFilters };
